import axios from 'axios'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui';
const service = axios.create({
  baseURL: '/api/Page',
  timeout: 10 * 1000,
  method: 'post'
})

service.interceptors.request.use(
  config => {
    config.headers['token'] = getToken()
    return config
  },
  error => {
    Message({ message: '响应超时.', type: 'warning' });
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    Message({ message: '响应超时.', type: 'warning' });
    return Promise.reject(error)
  }
)

export default service
